var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSmallBeigeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0021 17.9979C16.7369 17.9979 16.4826 17.8925 16.295 17.705C16.1075 17.5174 16.0021 17.2631 16.0021 16.9979V9.40786L7.71214 17.7079C7.52383 17.8962 7.26844 18.002 7.00214 18.002C6.73584 18.002 6.48044 17.8962 6.29214 17.7079C6.10383 17.5196 5.99805 17.2642 5.99805 16.9979C5.99805 16.7316 6.10383 16.4762 6.29214 16.2879L14.5921 7.99786H7.00214C6.73692 7.99786 6.48257 7.89251 6.29503 7.70497C6.1075 7.51743 6.00214 7.26308 6.00214 6.99786C6.00214 6.73265 6.1075 6.47829 6.29503 6.29075C6.48257 6.10322 6.73692 5.99786 7.00214 5.99786H17.0021C17.1328 5.99944 17.2619 6.02662 17.3821 6.07786C17.6265 6.17934 17.8207 6.37351 17.9221 6.61786C17.9734 6.73808 18.0006 6.86718 18.0021 6.99786V16.9979C18.0021 17.2631 17.8968 17.5174 17.7092 17.705C17.5217 17.8925 17.2674 17.9979 17.0021 17.9979Z",
    fill: "#F7F3EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmallBeigeArrow);
export default __webpack_public_path__ + "static/media/Icon-Small-Beige-Arrow.01cef9262edef16a646146bb5c9867dc.svg";
export { ForwardRef as ReactComponent };